import { Component, Input, Output, EventEmitter} from '@angular/core';


/**
   * Logger Factory
   * @namespace icon: is the name of value to show
   * @namespace title: is the title to show
*/

@Component({
  selector: 'ute-modal-drawer',
  templateUrl: 'ute-modal-drawer.component.html'
})
export class UteModalDrawerComponent {
  @Input()  isDrawerOpen: boolean;
  @Input()  cancel: boolean = false;
  @Input()  cancelLabel: string;
  @Input()  action: string;
  @Input()  actionLabel: string;
  @Input()  icon: string;
  @Input()  title: string;
  @Input()  isTransparent: boolean;
  @Input()  vertical: boolean;
  
  @Output() isDrawerOpenChange = new EventEmitter;
  @Output() onClickAction = new EventEmitter;

  constructor() {
  }

  ionViewDidLoad() {
  }

  onChangeDrawer(event){
    this.isDrawerOpenChange.emit(false);
  }
  onSubmitAction(event){
    this.onClickAction.emit(event);
  }

}


// WEBPACK FOOTER //
// ./src/app/components/commons/molecules/ute-modal-drawer/ute-modal-drawer.component.ts